import { convertToFullName } from "../../services/utils";
import { Member } from "./types";

const MEMBER_AVATAR_COLORS = [
  "primary.main",
  "secondary.main",
  "info.main",
  "success.main",
  "warning.main",
  "error.main",
];

const AVATAR_SIZE = 28;
const MEMBER_VISIBLE_MAX = 4;
const MEMBER_LIST_FONT_SIZE = 12;

function getMemberInitials(member: Member) {
  const name = convertToFullName(
    member?.firstName,
    member?.lastName
  ).trim();

  if (name) {
    const [first = "", second = ""] = name.split(/\s+/);
    return `${first[0] || ""}${second[0] || first[1] || ""}`.toUpperCase();
  }

  return (member?.email?.split("@")[0]?.slice(0, 2) || "?").toUpperCase();
}

function getMemberAvatarColors(count: number) {
  return Array.from(
    { length: count },
    () =>
      MEMBER_AVATAR_COLORS[
        Math.floor(Math.random() * MEMBER_AVATAR_COLORS.length)
      ]
  );
}

function resolveThemeColor(theme, colorPath: string) {
  const parts = colorPath.split(".");
  let value: any = theme.palette;

  for (const part of parts) {
    value = value?.[part];
  }

  return typeof value === "string" ? value : colorPath;
}

export {
  AVATAR_SIZE,
  getMemberAvatarColors,
  getMemberInitials,
  MEMBER_LIST_FONT_SIZE,
  MEMBER_VISIBLE_MAX,
  resolveThemeColor,
};
